export default function Footer() {
  return (
    <footer id="footer" className="relative bg-background-50 border-t border-background-200/30">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-lg text-white"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading">四虎影视大全</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              四虎影视大全 —— 国内领先的免费电视剧全集在线观看平台。海量国产剧资源每日更新，古装、悬疑、都市、仙侠全覆盖，高清画质免费畅享。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/50 hover:border-primary-500/30 text-foreground-500 hover:text-primary-400 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/50 hover:border-primary-500/30 text-foreground-500 hover:text-primary-400 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/50 hover:border-primary-500/30 text-foreground-500 hover:text-primary-400 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '首页', href: '#' },
                { label: '精选推荐', href: '#cards' },
                { label: '热播榜单', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    if (link.href !== '#') {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      e.preventDefault();
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                  className="block text-sm text-foreground-600 hover:text-primary-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">热门专题</h4>
            <div className="space-y-2.5">
              {['古装仙侠专题', '悬疑推理合集', '都市情感剧场', '谍战风云录', '经典老剧修复'].map((name) => (
                <a
                  key={name}
                  href="#index"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-sm text-foreground-600 hover:text-primary-400 transition-colors"
                >
                  {name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 四虎影视大全 sihumedia.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#contact" onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }} className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}